(function($) {
    $( window ).on( 'load', function(){

    	'use strict';

		const oneTrustDoNotSell = document.getElementsByClassName('aw-ot-show-settings')[0];

		if ( oneTrustDoNotSell !== undefined ) {
			oneTrustDoNotSell.innerHTML = '<!-- OneTrust Cookies Settings button start --> <button id="aw-ot-show-settings" class="ot-sdk-show-settings optanon-show-settings menu-item">Do Not Sell My Personal Information</button> <!-- OneTrust Cookies Settings button end -->';

			const awOneTrustButton = document.getElementById('aw-ot-show-settings');

			const awOneTrustButtonStyles = 'background: none; outline:none; color: #fff; text-transform: none; font-weight: 500; font-family: "Flama-Book","Helvetica Neue",Helvetica,Roboto,Arial,sans-serif; font-size: 16px; line-height: 22px; position: relative; bottom: 10px;';

			awOneTrustButton !== undefined ? awOneTrustButton.style.cssText = awOneTrustButtonStyles : '';
		}

    });
})(jQuery);